module.exports = __webpack_public_path__ + "img/logo.2803e72a.png";